'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _toArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/toArray");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var isIpfs = require('is-ipfs');

var cid = require('multiformats/cid');

var PeerId = require('peer-id');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

var utils = require('../utils.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var isIpfs__default = /*#__PURE__*/_interopDefaultLegacy(isIpfs);

var PeerId__default = /*#__PURE__*/_interopDefaultLegacy(PeerId);

function createResolve(_ref) {
  var repo = _ref.repo,
      codecs = _ref.codecs,
      bases = _ref.bases,
      name = _ref.name;

  function resolve(_x) {
    return _resolve.apply(this, arguments);
  }

  function _resolve() {
    _resolve = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path) {
      var opts,
          _iteratorAbruptCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          resolvedPath,
          _path$split,
          _path$split2,
          schema,
          hash,
          rest,
          base,
          bytes,
          str,
          cid$1,
          results,
          value,
          remainderPath,
          _iteratorAbruptCompletion2,
          _didIteratorError2,
          _iteratorError2,
          _iterator2,
          _step2,
          result,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              opts = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};

              if (isIpfs__default["default"].path(path)) {
                _context.next = 3;
                break;
              }

              throw new Error('invalid argument ' + path);

            case 3:
              if (!isIpfs__default["default"].ipnsPath(path)) {
                _context.next = 32;
                break;
              }

              _iteratorAbruptCompletion = false;
              _didIteratorError = false;
              _context.prev = 6;
              _iterator = _asyncIterator(name.resolve(path, opts));

            case 8:
              _context.next = 10;
              return _iterator.next();

            case 10:
              if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                _context.next = 16;
                break;
              }

              resolvedPath = _step.value;
              path = resolvedPath;

            case 13:
              _iteratorAbruptCompletion = false;
              _context.next = 8;
              break;

            case 16:
              _context.next = 22;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](6);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 22:
              _context.prev = 22;
              _context.prev = 23;

              if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                _context.next = 27;
                break;
              }

              _context.next = 27;
              return _iterator.return();

            case 27:
              _context.prev = 27;

              if (!_didIteratorError) {
                _context.next = 30;
                break;
              }

              throw _iteratorError;

            case 30:
              return _context.finish(27);

            case 31:
              return _context.finish(22);

            case 32:
              _path$split = path.split('/'), _path$split2 = _toArray(_path$split), schema = _path$split2[1], hash = _path$split2[2], rest = _path$split2.slice(3);

              if (!opts.cidBase) {
                _context.next = 39;
                break;
              }

              _context.next = 36;
              return bases.getBase(opts.cidBase);

            case 36:
              _context.t1 = _context.sent;
              _context.next = 40;
              break;

            case 39:
              _context.t1 = undefined;

            case 40:
              base = _context.t1;
              bytes = parseBytes(hash);

              if (!(rest.length === 0)) {
                _context.next = 45;
                break;
              }

              str = base ? base.encoder.encode(bytes) : hash;
              return _context.abrupt("return", "/".concat(schema, "/").concat(str));

            case 45:
              cid$1 = cid.CID.decode(bytes);
              path = rest.join('/');
              results = utils.resolve(cid$1, path, codecs, repo, opts);
              value = cid$1;
              remainderPath = path;
              _iteratorAbruptCompletion2 = false;
              _didIteratorError2 = false;
              _context.prev = 52;
              _iterator2 = _asyncIterator(results);

            case 54:
              _context.next = 56;
              return _iterator2.next();

            case 56:
              if (!(_iteratorAbruptCompletion2 = !(_step2 = _context.sent).done)) {
                _context.next = 62;
                break;
              }

              result = _step2.value;

              if (cid.CID.asCID(result.value)) {
                value = result.value;
                remainderPath = result.remainderPath;
              }

            case 59:
              _iteratorAbruptCompletion2 = false;
              _context.next = 54;
              break;

            case 62:
              _context.next = 68;
              break;

            case 64:
              _context.prev = 64;
              _context.t2 = _context["catch"](52);
              _didIteratorError2 = true;
              _iteratorError2 = _context.t2;

            case 68:
              _context.prev = 68;
              _context.prev = 69;

              if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
                _context.next = 73;
                break;
              }

              _context.next = 73;
              return _iterator2.return();

            case 73:
              _context.prev = 73;

              if (!_didIteratorError2) {
                _context.next = 76;
                break;
              }

              throw _iteratorError2;

            case 76:
              return _context.finish(73);

            case 77:
              return _context.finish(68);

            case 78:
              return _context.abrupt("return", "/ipfs/".concat(value.toString(base && base.encoder)).concat(remainderPath ? '/' + remainderPath : ''));

            case 79:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 18, 22, 32], [23,, 27, 31], [52, 64, 68, 78], [69,, 73, 77]]);
    }));
    return _resolve.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(resolve);
}

function parseBytes(str) {
  try {
    return PeerId__default["default"].parse(str).toBytes();
  } catch (_unused) {
    return cid.CID.parse(str).bytes;
  }
}

exports.createResolve = createResolve;